/* API requests */
import { updateUser } from "../api-requests/user";

export const saveUser = (body, user) => {

    return updateUser(user._id, body);

}